// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3YR58","cell":"ColumnAccessor_cell__3Nqug","firstCellAccent":"ColumnAccessor_firstCellAccent__1MIaa"};